import MonegraphERC721FactoryJSON from './MonegraphERC721Factory.json';

const contract = require('@truffle/contract');

export default contract({
  abi: MonegraphERC721FactoryJSON.abi,
});
